import { Stack } from '@fluentui/react';
import React from 'react';
import { injectIntlAndObserver, IRouterWithIntl } from '../../../../utils';
import { ICustomCalenderDateRange } from '../../components/CustomCalender/CustomCalender.types';
import { ChartTypes, ReportCardType } from '../../DashboardCards/ReportCard/ReportCard.types';
import { getClassNames } from '../../DashboardCards/TythonReportCards.styles';
import { ALLOWED_CHARTS } from '../utils/constants';
import { PubCenterChartCard } from './PubCenterChartCard';
import { PubCenterReportCard } from './PubCenterReportCard';

export interface IPubcenterOverviewReportCardsProps extends IRouterWithIntl {
  dateRange: ICustomCalenderDateRange;
  reports: ReportCardType[];
}

export const PubcenterOverviewReportCards = injectIntlAndObserver((props: IPubcenterOverviewReportCardsProps) => {
  const classNames = getClassNames(props);
  const { reports } = props;

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <Stack>
        <Stack.Item grow basis={'100%'} style={{ width: '100%' }}>
          {reports.map(
            (report) =>
              ALLOWED_CHARTS[report]?.some((i) => i.chartType === ChartTypes.LINE) && <PubCenterChartCard {...props} reportType={report} />
          )}
        </Stack.Item>
      </Stack>
      <Stack>
        <div className={classNames.reportCard}>
          {reports.map(
            (report) =>
              ALLOWED_CHARTS[report]?.every((i) => i.chartType !== ChartTypes.LINE) && (
                <div key={report}>
                  <PubCenterReportCard {...props} reportType={report} />
                </div>
              )
          )}
        </div>
      </Stack>
    </Stack>
  );
});
